import React, { createContext, useContext, useEffect, useState } from 'react';
import { translations } from '../mock/data';

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem('capcut_lang') || 'sv');
  const [theme, setTheme] = useState(() => localStorage.getItem('capcute_theme') || 'light');

  useEffect(() => {
    localStorage.setItem('capcut_lang', lang);
    document.documentElement.dir = translations[lang].dir;
    document.documentElement.lang = lang;
  }, [lang]);

  useEffect(() => {
    localStorage.setItem('capcute_theme', theme);
    document.documentElement.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  const toggleTheme = () => setTheme(prev => prev === 'dark' ? 'light' : 'dark');

  const t = translations[lang];
  return (
    <LangContext.Provider value={{ lang, setLang, t, theme, toggleTheme }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error('useLang must be used inside LangProvider');
  return ctx;
};
